import gql from 'graphql-tag'

export const GET_VEHICLES_BY_TYPE = gql`
    query ($orgId:uuid!,$vehicleType: String!){
        Vehicles: Vehicles(where: {organizationId: {_eq: $orgId}, type: {_eq: $vehicleType}}){
            id
            name
            platNo
        }
    }`
